import axios from '@/axiosr8'

class PointAlarmsProvider {
  async getAlgorithms () {
    let result = await axios.get('possonline/alarms/points/algorithms')
    return result.data
  }

  async getAlgorithmSettings (asset) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings')
    return result.data
  }

  async getHealthScore (asset, from, to, direction, days) {
    let result = await axios.get('possonline/alarms/points/' + btoa(asset.UniqueId) + '/trends', { params: {
      dtFrom: from,
      dtTo: to,
      direction: direction,
      days: days
    }})
    return result.data
  }

  async createAlgorithmSetting (asset, algorithmSetting) {
    let result = await axios.post('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings', algorithmSetting)
    return result.data
  }

  async updateAlgorithmSetting (asset, algorithmSetting) {
    let result = await axios.put('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings/' + algorithmSetting.id, algorithmSetting)
    return result.data
  }

  async removeAlgorithmSetting (asset, id) {
    let result = await axios.delete('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings/' + id)
    return result.data
  }

  async previewBackgroundWorker (asset, algorithmSetting) {
    let result = await axios.post('possonline/alarms/points/' + btoa(asset.UniqueId) + '/algorithmsettings/previewbackgroundworker', algorithmSetting)
    return result.data
  }
}

export default new PointAlarmsProvider()



// WEBPACK FOOTER //
// ./src/providers/PointAlarmsProvider.js